import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './TaskBoard.module.css';
import { useTaskBoard } from './useTaskBoard';
import { TasksBlock } from './Blocks/TasksBlock/TasksBlock';
import { useAppSelector } from '../../../store';
import { TaskBoardSkeleton } from './BoardTaskSkeleton';

interface TaskBoardProps {
    classes?: string;
}

export const TaskBoard = memo(({ classes }: TaskBoardProps) => {
    const {} = useTaskBoard();
    const { isLoading } = useAppSelector((state) => state.tasksReducer);

    if (isLoading) {
        return <TaskBoardSkeleton />;
    }

    return (
        <div className={classNames(cls.TaskBoard, [classes])}>
            <TasksBlock />
        </div>
    );
});
